module.exports = __webpack_public_path__ + "img/sz.szbec727f.svg";